/* ═══════════════════════════════════════
   OBB Product Hero — JavaScript
   Gallery, Sticky ATC, Accordions,
   Quantity Stepper
   ═══════════════════════════════════════ */

document.addEventListener('alpine:init', () => {

  /* ─── Shared state for cross-component reactivity ─── */
  Alpine.store('chew', { flavor: 'Plain Beef', size: 'M' });

  /* ─── Gallery ─── */
  Alpine.data('obbGallery', () => ({
    current: 0,
    total: 0,
    lightboxOpen: false,
    lightboxSrc: '',

    init() {
      const slides = this.$el.querySelectorAll('.obb-gallery__slide');
      this.total = slides.length;
      if (this.total > 0) slides[0].classList.add('obb-gallery__slide--active');

      // Track scroll position for dot indicators on mobile
      const slidesContainer = this.$el.querySelector('.obb-gallery__slides');
      if (slidesContainer) {
        slidesContainer.addEventListener('scroll', () => {
          const scrollLeft = slidesContainer.scrollLeft;
          const slideWidth = slidesContainer.offsetWidth;
          this.current = Math.round(scrollLeft / slideWidth);
        });
      }
    },

    goTo(index) {
      // Active slide is bound reactively via :class="current === index" on each slide.
      this.current = index;

      // Mobile: scroll the swipe container to the chosen slide.
      const slidesContainer = this.$el.querySelector('.obb-gallery__slides');
      if (window.innerWidth < 768 && slidesContainer) {
        slidesContainer.scrollTo({
          left: index * slidesContainer.offsetWidth,
          behavior: 'smooth'
        });
      }
    },

    openLightbox(src) {
      this.lightboxSrc = src;
      this.lightboxOpen = true;
      document.body.style.overflow = 'hidden';
    },

    closeLightbox() {
      this.lightboxOpen = false;
      document.body.style.overflow = '';
    }
  }));

  /* ─── Quantity Stepper ─── */
  Alpine.data('obbQuantity', (config) => ({
    qty: config.initial || 1,
    min: config.min || 1,
    max: config.max || 10,

    decrease() {
      if (this.qty > this.min) this.qty--;
    },

    increase() {
      if (this.qty < this.max) this.qty++;
    }
  }));

  /* ─── Collagen Chew Purchase Card ─── */
  Alpine.data('obbCollagenPurchase', () => ({
    variants: [],
    selectedFlavor: '',
    selectedSize: '',
    selectedVariantId: null,
    selectedPrice: 0,
    selectedAvailable: true,
    packQty: 3,
    flavorOpen: false,
    purchaseType: 'onetime',
    sellingPlanIds: [],
    selectedCadenceId: '',

    // ── STOREFRONT FLAVOR ALLOWLIST (collagen retail PDP) ──────────────────────────
    // ONLY these flavors render in the dropdown. All 7 flavor variants stay fully alive
    // in admin (none deleted/disabled) — this is a render filter only. Edit this list to
    // change which flavors show on the storefront. KEEP IN SYNC with the wholesale picker:
    // sections/obb-wholesale-pdp.liquid -> collagen_flavor_allowlist.
    // Hidden 2026-06-07: 'Chicken & Parsley', 'Kangaroo', "Goat's Milk".
    flavors: [
      'Plain Beef', 'Beef Liver', 'Peanut Butter', 'Maple Bacon'
    ],

    flavorColors: {
      'Plain Beef': '#B61712',
      'Beef Liver': '#B61712',
      'Peanut Butter': '#CD5210',
      'Chicken & Parsley': '#7758A2',
      'Kangaroo': '#E83E25',
      "Goat's Milk": '#CD3F90',
      'Maple Bacon': '#CC4D4D'
    },

    sizes: [
      { value: 'S',    display: 'S \u00b7 50g' },
      { value: 'M',    display: 'M \u00b7 100g' },
      { value: 'L',    display: 'L \u00b7 150g' }
    ],

    packs: [
      { qty: 1, label: '1 Pack', badge: '' },
      { qty: 3, label: '3 Pack', badge: 'Save 5%' },
      { qty: 5, label: '5 Pack', badge: 'Save 10%' }
    ],

    get subscribePrice() {
      return this.selectedPrice * this.packQty * 0.90;
    },

    get oneTimePrice() {
      const obchewMultiplier =
        this.packQty >= 5 ? 0.90 :
        this.packQty >= 3 ? 0.95 :
        1.00;
      return this.selectedPrice * this.packQty * obchewMultiplier;
    },

    get msrpTotal() {
      return this.selectedPrice * this.packQty;
    },

    get totalPrice() {
      return this.purchaseType === 'subscribe'
        ? this.subscribePrice
        : this.oneTimePrice;
    },

    init() {
      const jsonEl = document.getElementById('obb-variant-json');
      if (jsonEl) {
        const data = JSON.parse(jsonEl.textContent);
        this.variants = data.variants;
        this.selectedFlavor = data.currentFlavor || 'Plain Beef';
        this.selectedSize = data.currentSize || 'M';
        this.selectedVariantId = data.currentVariantId;
        this.selectedPrice = data.currentPrice;
      }
      // Override defaults: Plain Beef / M / 3 Pack / Subscribe (30-day default cadence)
      this.selectedFlavor = 'Plain Beef';
      this.selectedSize = 'M';
      this.packQty = 3;
      try {
        this.sellingPlanIds = JSON.parse(this.$root.dataset.sellingPlanIds || '[]');
      } catch (e) {
        this.sellingPlanIds = [];
      }
      this.selectedCadenceId = this.sellingPlanIds[0] || '';
      Alpine.store('chew').flavor = 'Plain Beef';
      Alpine.store('chew').size = 'M';
      this.resolveVariant();
      this.selectPurchaseType('onetime');

      // Belt-and-suspenders: Subify may inject its own [name="selling_plan"] input
      // asynchronously after init() runs. Watch for late additions anywhere in the
      // DOM and normalize them to match our purchaseType state. Closes a race
      // window where a customer landing on the PDP could click ATC immediately —
      // before any purchase-card click — and submit with a Subify-populated
      // selling_plan that doesn't match the intended UI state.
      //
      // Observer is never disconnected: Subify may re-inject on variant change
      // during the page session. The inner forEach is cheap (1-2 inputs in
      // practice) so running on every body mutation is acceptable.
      new MutationObserver(() => {
        const expectedValue = this.purchaseType === 'subscribe'
          ? (this.selectedCadenceId || '')
          : '';
        document.querySelectorAll('input[name="selling_plan"]').forEach(input => {
          if (input.value !== expectedValue) {
            input.value = expectedValue;
          }
        });
      }).observe(document.body, {
        childList: true,
        subtree: true,
      });
    },

    flavorColor(name) {
      return this.flavorColors[name] || '#999';
    },

    selectFlavor(flavor) {
      this.selectedFlavor = flavor;
      this.flavorOpen = false;
      Alpine.store('chew').flavor = flavor;
      this.resolveVariant();
    },

    selectSize(size) {
      this.selectedSize = size;
      Alpine.store('chew').size = size;
      this.resolveVariant();
    },

    selectPack(qty) {
      this.packQty = qty;
    },

    selectPurchaseType(type) {
      this.purchaseType = type;
      if (type === 'subscribe' && !this.selectedCadenceId) {
        this.selectedCadenceId = this.sellingPlanIds[0] || '';
      }
      const planId = type === 'subscribe' ? (this.selectedCadenceId || '') : '';
      document.querySelectorAll('input[name="selling_plan"]').forEach(input => {
        input.value = planId;
      });
    },

    selectCadence(planId) {
      this.selectedCadenceId = planId;
      document.querySelectorAll('input[name="selling_plan"]').forEach(input => {
        input.value = planId;
      });
    },

    resolveVariant() {
      const match = this.variants.find(
        v => v.size === this.selectedSize && v.flavor === this.selectedFlavor
      );
      if (match) {
        this.selectedVariantId = match.id;
        this.selectedPrice = match.price;
        this.selectedAvailable = match.available;
      } else {
        this.selectedAvailable = false;
      }
    },

    formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }
  }));

  /* ─── Simple Purchase Card (every non-collagen product) ─── */
  Alpine.data('obbSimplePurchase', () => ({
    variants: [],
    optionNames: [],
    sizeIdx: -1,
    flavorIdx: -1,
    hasSize: false,
    hasFlavor: false,
    sizeValues: [],
    flavorValues: [],
    selectedSize: '',
    selectedFlavor: '',
    selectedVariantId: null,
    selectedPrice: 0,
    selectedAvailable: true,
    qty: 1,
    qtyMin: 1,
    qtyMax: 99,
    purchaseType: 'onetime',
    hasSubscription: false,
    sellingPlanIds: [],
    selectedCadenceId: '',
    variantSizeNotes: {},

    // Reactive per-variant size note (e.g. ostrich-knuckle Small/Large). Reads the already-maintained
    // selectedVariantId — does NOT touch resolveVariant. Empty/absent note → '' → block hidden.
    get sizeNote() { return this.variantSizeNotes[this.selectedVariantId] || ''; },

    // Displayed prices are unit price × line quantity (the proven cart multiplier), NOT pack math.
    // qty means: units per order (one-time) OR units per recurring shipment (subscribe) —
    // e.g. "$67.47 / Delivered every 30 days" = 3 units every 30 days.
    get unitPrice() { return this.selectedPrice; },
    get msrpTotal() { return this.selectedPrice * this.qty; },
    get subscribeTotal() { return this.selectedPrice * 0.90 * this.qty; },
    get oneTimeTotal() { return this.selectedPrice * this.qty; },
    get selectedTotal() { return this.purchaseType === 'subscribe' ? this.subscribeTotal : this.oneTimeTotal; },

    init() {
      const el = document.getElementById('obb-simple-variant-json');
      if (el) {
        const data = JSON.parse(el.textContent);
        this.variants = data.variants || [];
        this.variantSizeNotes = {};
        this.variants.forEach(v => { if (v.sizeNote) this.variantSizeNotes[v.id] = v.sizeNote; });
        this.optionNames = data.optionNames || [];
        this.hasSubscription = !!data.hasSubscription;
        this.selectedVariantId = data.currentVariantId;
        this.selectedPrice = data.currentPrice;
      }
      this.sizeIdx = this.optionNames.findIndex(n => n === 'Size');
      this.flavorIdx = this.optionNames.findIndex(n => n === 'Flavor');
      this.hasSize = this.sizeIdx >= 0;
      this.hasFlavor = this.flavorIdx >= 0;
      if (this.hasSize) {
        this.sizeValues = [...new Set(this.variants.map(v => v.options[this.sizeIdx]).filter(Boolean))];
      }
      if (this.hasFlavor) {
        this.flavorValues = [...new Set(this.variants.map(v => v.options[this.flavorIdx]).filter(Boolean))];
      }
      const cur = this.variants.find(v => v.id === this.selectedVariantId) || this.variants[0];
      if (cur) {
        if (this.hasSize) this.selectedSize = cur.options[this.sizeIdx];
        if (this.hasFlavor) this.selectedFlavor = cur.options[this.flavorIdx];
      }
      try {
        this.sellingPlanIds = JSON.parse(this.$root.dataset.sellingPlanIds || '[]');
      } catch (e) {
        this.sellingPlanIds = [];
      }
      this.selectedCadenceId = this.sellingPlanIds[0] || '';
      // Fail safe: only default to subscribe when a plan actually exists.
      // Global default is One-Time on every PDP type. Subscribe still renders + works on toggle.
      this.purchaseType = 'onetime';
      this.resolveVariant();
      this.selectPurchaseType(this.purchaseType);

      // Subify may inject [name="selling_plan"] late; keep it normalized to our state.
      new MutationObserver(() => {
        const expected = this.purchaseType === 'subscribe' ? (this.selectedCadenceId || '') : '';
        document.querySelectorAll('input[name="selling_plan"]').forEach(input => {
          if (input.value !== expected) input.value = expected;
        });
      }).observe(document.body, { childList: true, subtree: true });
    },

    selectFlavor(flavor) { this.selectedFlavor = flavor; this.resolveVariant(); },
    selectSize(size) { this.selectedSize = size; this.resolveVariant(); },
    decreaseQty() { if (this.qty > this.qtyMin) this.qty--; },
    increaseQty() { if (this.qty < this.qtyMax) this.qty++; },

    selectPurchaseType(type) {
      this.purchaseType = type;
      if (type === 'subscribe' && !this.selectedCadenceId) {
        this.selectedCadenceId = this.sellingPlanIds[0] || '';
      }
      const planId = type === 'subscribe' ? (this.selectedCadenceId || '') : '';
      document.querySelectorAll('input[name="selling_plan"]').forEach(input => {
        input.value = planId;
      });
    },

    selectCadence(planId) {
      this.selectedCadenceId = planId;
      document.querySelectorAll('input[name="selling_plan"]').forEach(input => {
        input.value = planId;
      });
    },

    resolveVariant() {
      let match = null;
      if (this.hasSize && this.hasFlavor) {
        match = this.variants.find(v => v.options[this.sizeIdx] === this.selectedSize && v.options[this.flavorIdx] === this.selectedFlavor);
      } else if (this.hasSize) {
        match = this.variants.find(v => v.options[this.sizeIdx] === this.selectedSize);
      } else if (this.hasFlavor) {
        match = this.variants.find(v => v.options[this.flavorIdx] === this.selectedFlavor);
      } else {
        match = this.variants[0];
      }
      if (match) {
        this.selectedVariantId = match.id;
        this.selectedPrice = match.price;
        this.selectedAvailable = match.available;
      } else {
        this.selectedAvailable = false;
      }
    },

    formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }
  }));

  /* ─── Read-more (expandable short description) ─── */
  Alpine.data('obbReadMore', (cfg) => ({
    expanded: false,
    twoField: !!(cfg && cfg.twoField),
    hasTeaser: !!(cfg && cfg.hasTeaser),
    canExpand: false,

    init() {
      if (this.twoField) {
        // Distinct fuller text exists — always offer the toggle.
        this.canExpand = true;
      } else {
        // Single-field clamp: only offer the toggle if the text actually overflows 3 lines.
        this.$nextTick(() => {
          const el = this.$refs.clamp;
          this.canExpand = !!el && el.scrollHeight > el.clientHeight + 2;
        });
      }
    },

    toggle() { this.expanded = !this.expanded; }
  }));

  /* ─── Accordion ─── */
  Alpine.data('obbAccordion', () => ({
    open: false,

    toggle() {
      this.open = !this.open;
    }
  }));
});

/* ─── Sticky Mobile ATC Bar (IntersectionObserver) ─── */
document.addEventListener('DOMContentLoaded', () => {
  const heroAtc = document.querySelector('.obb-atc-btn');
  const stickyBar = document.querySelector('.obb-sticky-atc');

  if (!heroAtc || !stickyBar) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        stickyBar.classList.toggle('obb-sticky-atc--visible', !entry.isIntersecting);
      });
    },
    { threshold: 0, rootMargin: '0px' }
  );

  observer.observe(heroAtc);

  // Sticky bar ATC click submits the main product form
  const stickyBtn = stickyBar.querySelector('.obb-sticky-atc__btn');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', () => {
      const form = document.getElementById('obb-product-form');
      if (form) {
        form.requestSubmit();
      } else {
        heroAtc.click();
      }
    });
  }
});
